import type { VendorMetadataExtractor } from './types'
import { genericExtractor } from './generic'
import { teslaExtractor } from './tesla'
import { blackvueExtractor } from './blackvue'
import { viofoExtractor } from './viofo'
import { garminExtractor } from './garmin'
import { nextbaseExtractor } from './nextbase'

const extractors: VendorMetadataExtractor[] = [
  teslaExtractor,
  blackvueExtractor,
  viofoExtractor,
  garminExtractor,
  nextbaseExtractor
  // genericExtractor is the fallback — keep last
]

export function getExtractor(vendorId: string | null | undefined): VendorMetadataExtractor {
  return extractors.find((e) => e.vendorId === vendorId) ?? genericExtractor
}
